export default "__VITE_ASSET__CKPekLJ8__"